import { useFormContext } from 'react-hook-form';
import { Button, ButtonProps } from 'components/Button';
import { useFormValidation } from 'domains/form-validation';

type Props = {
  /**
   * If the submit handler will redirect after a successful submission, the
   * button will retain its loading state while the route transition happens.
   *
   * Set this to `false` if there's no redirect expected after submission.
   */
  willRedirect?: boolean;
  disableIfInvalid?: boolean;
} & ButtonProps<'button'>;

export const SubmitButton = ({
  willRedirect = true,
  loading = false,
  disableIfInvalid = false,
  ...props
}: Props): JSX.Element => {
  const { formState } = useFormContext();
  const { disabled } = useFormValidation();
  const { isSubmitting, isValidating, isSubmitSuccessful, isValid } = formState;
  const isLoading = loading || isValidating || isSubmitting || (willRedirect && isSubmitSuccessful);

  const isDisabled = disabled || (disableIfInvalid && (!isValid || isValidating));

  return (
     
    <Button disabled={isDisabled} {...props} type="submit" loading={isLoading} />
  );
};
